import { useState, useEffect } from 'react'
import { router } from '@inertiajs/react'
import { RockFilters as RockFiltersType } from '../../types'

interface Props {
  teamId: number
  filters: RockFiltersType
}

export default function RockFilters({ teamId, filters }: Props) {
  const [search, setSearch] = useState(filters.search || '')

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search !== (filters.search || '')) {
        applyFilter('search', search || undefined)
      }
    }, 300)
    return () => clearTimeout(timer)
  }, [search])

  const applyFilter = (key: string, value: string | undefined) => {
    const params: Record<string, string | undefined> = {
      search: filters.search,
      tab: filters.tab,
      state: filters.state,
      due_date: filters.due_date,
      sort_by: filters.sort_by,
      group_by: filters.group_by,
      [key]: value,
    }
    const clean: Record<string, string> = {}
    Object.entries(params).forEach(([k, v]) => { if (v) clean[k] = v })
    router.get(`/teams/${teamId}/rocks`, clean, { preserveState: true, preserveScroll: true })
  }

  return (
    <div className="bg-[#F5F5F5]/30 rounded-lg p-3 flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[200px]">
        <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search rocks..."
          className="w-full pl-9 pr-3 py-1.5 border border-stone/30 rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20 focus:border-pinnacle-red bg-white"
        />
      </div>

      <select
        value={filters.due_date || ''}
        onChange={e => applyFilter('due_date', e.target.value || undefined)}
        className="px-3 py-1.5 border border-stone/30 rounded-lg text-sm text-text-primary bg-white focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20"
      >
        <option value="">All Quarters</option>
        <option value="current_quarter">Current Quarter</option>
        <option value="next_quarter">Next Quarter</option>
      </select>

      {filters.tab !== 'backlog' && (
        <select
          value={filters.state || ''}
          onChange={e => applyFilter('state', e.target.value || undefined)}
          className="px-3 py-1.5 border border-stone/30 rounded-lg text-sm text-text-primary bg-white focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20"
        >
          <option value="">Active</option>
          <option value="archived">Archived</option>
        </select>
      )}

      <select
        value={filters.sort_by || 'position'}
        onChange={e => applyFilter('sort_by', e.target.value)}
        className="px-3 py-1.5 border border-stone/30 rounded-lg text-sm text-text-primary bg-white focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20"
      >
        <option value="position">Manual Order</option>
        <option value="title">Name (A-Z)</option>
        <option value="due_date">Due Date</option>
        <option value="status">% Complete</option>
        <option value="last_check_in">Last Check-in</option>
      </select>

      <select
        value={filters.group_by || 'none'}
        onChange={e => applyFilter('group_by', e.target.value)}
        className="px-3 py-1.5 border border-stone/30 rounded-lg text-sm text-text-primary bg-white focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20"
      >
        <option value="none">No Grouping</option>
        <option value="owner">Group by Owner</option>
        <option value="category">Group by Category</option>
      </select>
    </div>
  )
}
